export const typeDestinationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Tipo Destinazione',
    path: '/sistema/eventmanager/tipidestinazione',
  },
];
